import { toast } from 'react-toastify';
import { UiToastAdapter } from '../logic';

export function reduceServerErrors(state) {
  const errors = state.errorMessage ? state.errorMessage() : state.error.body;
  if (errors.detail) {
    toast(UiToastAdapter(errors.detail, 'danger'));
    return undefined;
  }
  const fieldErrors = Object.entries(errors).reduce(
    (messages, [key, value]) => {
      if (value && Array.isArray(value)) {
        // eslint-disable-next-line no-param-reassign
        [messages[key]] = value;
      }
      return messages;
    },
    {}
  );
  const fieldErrorValues = Object.values(fieldErrors).filter(e => !!e);
  if (fieldErrorValues.length > 0) {
    fieldErrorValues.forEach(error => toast(UiToastAdapter(error, 'danger')));
    return fieldErrors;
  }
  toast(
    UiToastAdapter(
      'An error occurred. Please, try again later or contact Solvent.',
      'danger'
    )
  );
  return undefined;
}
